// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2aSd4","productName":"Table_productName__1LFVm"};